module.exports = __webpack_public_path__ + "static/img/12.88061365.png";